import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import auth from './modules/auth.js'
import transition from './modules/transition.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    transition
  },
  state: {
    loading: false,
    forbidden: false,
    progressState: false,
    progress: 0
  },
  mutations: {
    onLoading (state, mode) {
      state.loading = mode
    },
    forbidden (state, mode) {
      state.forbidden = mode
    },
    inProgress (state, mode) {
      state.progressState = mode
    },
    setProgress (state, mode) {
      state.progress = mode
    }
  },
  plugins: [createPersistedState()]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js